import { IconButton, IconButtonProps } from '@chakra-ui/react';
import MuiIcon from 'components/MuiIcon';
import React from 'react';
import useGetColors from 'shared/hooks/useGetColors';
import useHandleCopy from 'shared/hooks/useHandleCopy';

interface Props extends Omit<IconButtonProps, 'aria-label'> {
  text: string
  'aria-label'?: string,
}

const CopyButton = ({ text, ...props }: Props) => {
  const handleCopy = useHandleCopy();
  const { gray100 } = useGetColors();

  return (
    <IconButton
      aria-label="copy-text"
      size="xs"
      _hover={{
        backgroundColor: gray100,
      }}
      onClick={() => handleCopy(text)}
      {...props}
    >
      <MuiIcon name="content_copy" />
    </IconButton>
  );
}

export default CopyButton;
